function duration(value) {
    value = Math.ceil(value);

    if (value < 60) {
        if (value < 10) {
            value = '0' + value;
        }
        return '0:'+value;
    }

    var hours = Math.floor(value / 60);
    var minutes = value % 60;
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    return hours+':'+minutes;
}

export default duration;



// WEBPACK FOOTER //
// ./src/filters/duration.js